// extracted by mini-css-extract-plugin
export default {"container":"cardDelivery_container__vW-xH"};